import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators, compose } from 'redux';
import values from 'lodash/values';


import {
  loadPendingUsers
} from '../../shared/redux/entities/actions';

function mapStateToProps(state){
  //TODO: Connect Redux state to ProviderPendingUserList
  return {
    users:values(state.entities.users).filter((u) => !u.invitationAccepted && !u.agencyId)
  };
}

function mapDispatchToProps(dispatch){
  //TODO: Bind Redux action creators to ProviderPendingUserList
  return bindActionCreators({ loadPendingUsers },dispatch);
}

export default compose(
  withRouter,
  connect(mapStateToProps,mapDispatchToProps)
);



// WEBPACK FOOTER //
// ./src/routes/ProviderPendingUserList/connect.js